var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "pen",
    d: "M887.016,209.651l-69.3-69.3a95.575,95.575,0,0,0-130.807-4.079l-.1-.1-2.642,2.642c-.54.516-1.092,1.012-1.623,1.542h0l.04.04L163.645,659.328l.032.033a12.985,12.985,0,0,0-4.808,9.335L111.68,872.358a27.436,27.436,0,0,0,34.594,37.449l212.882-41.323a12.976,12.976,0,0,0,2.4-.466l.086-.017V868a13.021,13.021,0,0,0,6.373-4.3l.109.11L891.287,340.65l-.191-.192A95.576,95.576,0,0,0,887.016,209.651ZM729.593,424.026l-31.358,31.359L572.458,329.608l31.359-31.358ZM337.735,815.885,173.983,847.672l36.065-155.653L532.86,369.206,658.637,494.983Zm515.42-515.42-83.916,83.916L643.493,258.634l83.916-83.915a32,32,0,0,1,45.255,0l80.491,80.491A32,32,0,0,1,853.155,300.465Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewpen);
export default __webpack_public_path__ + "static/media/newpen.9efa16b1.svg";
export { ForwardRef as ReactComponent };